export function formatPhoneNumber(phoneNumber: string) {
    // 정규 표현식을 사용하여 핸드폰 번호를 포맷팅
    const formattedNumber = phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    return formattedNumber;
  }